import classNames from 'classnames/bind';
import styles from './ContactUs.module.scss';
import { AppBar, Box, Typography, Card, CardHeader } from '@mui/material';
import { images } from '~/assets';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

const ContactUs = () => {
  const { t } = useTranslation(['admin/common']);

  return (
    <Box className={cx('w-full', 'h-full')}>
      {/* Header */}
      <AppBar
        color='inherit'
        className={cx('px-4 md:px-20 py-2.5 border-b border-[#E5EAEF]')}
        elevation={0}
        position='relative'
      >
        <Box className={cx('flex justify-between items-center')}>
          <img src={images.logo} alt='Logo' className={cx('w-[61px] h-[62px]')} />
          <Box className={cx('h-9')}></Box>
        </Box>
      </AppBar>

      <Box className={cx('container', 'p-4 md:p-20 flex flex-col items-center')}>
        <Typography className={cx('contact-title', 'mb-8')}>{t('contactus')}</Typography>

        <Card className={cx('card', 'mb-4')}>
          <Box className={cx('box-card')}>
            <CardHeader title={<Typography className={cx('card-title-header')}>{t('Email')}</Typography>} />
            <CardHeader title={<Typography className={cx('card-title')}>phoenixtechapp@gmail.com</Typography>} />
          </Box>

          <Box className={cx('box-card')}>
            <CardHeader title={<Typography className={cx('card-title-header')}>{t('Phone Number')}</Typography>} />
            <CardHeader title={<Typography className={cx('card-title')}>(720) 204-2095</Typography>} />
          </Box>

          <Box className={cx('box-card')}>
            <CardHeader title={<Typography className={cx('card-title-header')}>{t('website')}</Typography>} />
            <CardHeader title={<Typography className={cx('card-title')}>www.borestoration.com</Typography>} />
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default ContactUs;
